<template>
  <v-main>
    <v-container>
      <v-card elevation="6">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a {{ $route.query.type }} Module
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="project"
                v-model="form.project_id"
                :items="projectItems"
                label="Select Project"
                prepend-inner-icon="mdi-ferry"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="category"
                v-model="form.category_id"
                :items="categoryItems"
                @change="getSubCategory"
                label="Select Category"
                prepend-inner-icon="mdi-ferry"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col sm="4" v-if="sub_categoryItems.length">
              <v-autocomplete
                ref="sub_category"
                v-model="form.sub_category_id"
                :items="sub_categoryItems"
                label="Select Sub Category"
                prepend-inner-icon="mdi-ferry"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col sm="4" v-if="sub_sub_categoryItems.length">
              <v-autocomplete
                ref="sub_sub_category"
                v-model="form.sub_sub_category_id"
                :items="sub_sub_categoryItems"
                label="Select Sub Sub Category"
                prepend-inner-icon="mdi-ferry"
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn v-else color="primary" dark @click="save"> Save Module </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "ModuleCreatePage",
  data() {
    return {
      form: {
        name: "",
        project_id: "",
        category_id: "",
        sub_category_id: "",
        sub_sub_category_id: "",
      },
      projectItems: [],
      categoryItems: [],
      sub_categories: [],
      sub_categoryItems: [],
      sub_sub_categoryItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.form.site_id = this.site.id;
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get(
        `modules/masters?type=${this.$route.query.type}`
      );
      masters = masters.data;
      masters.projects.forEach((project) => {
        this.projectItems.push({
          id: project.id,
          text: project.name,
          value: project.id,
        });
      });
      masters.categories.forEach((category) => {
        this.categoryItems.push({
          id: category.id,
          text: category.name,
          value: category.id,
        });
        if (category.value_lists.length) {
          category.value_lists.forEach((sub_category) => {
            this.sub_categories.push(sub_category);
            this.sub_categoryItems.push({
              id: sub_category.id,
              text: sub_category.description,
              value: sub_category.id,
              value_id: sub_category.value_id,
            });
          });
        }
      });
      if (this.$route.query.type == "GENERAL")
        this.form.category_id = this.categoryItems[0];
      console.log(this.sub_categoryItems);
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/modules", this.form);
        this.isLoading = false;
        this.$router.push(`/modules?type=${this.$route.query.type}`);
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
    getSubCategory() {
      this.sub_categoryItems = [];
      this.sub_sub_categoryItems = [];
      this.form.sub_category_id = "";
      this.form.sub_sub_category_id = "";
      let sub_category = this.sub_categories.filter(
        (sub_category) => sub_category.value_id == this.form.category_id
      );
      sub_category.forEach((sc) => {
        this.sub_categoryItems.push({
          id: sc.id,
          text: sc.description,
          value: sc.id,
          value_id: sc.value_id,
        });
      });
    },
  },
};
</script>
